import { localStorageGet } from '../../utils';

/**
 * Cache key for the region's `uiSettings.scheduledEmailsEnabled`. Written by
 * ClientSettingsService on every settings load, read here - the same pair the
 * Discharge Plan and RiskAI entitlements use.
 */
export const SCHEDULED_EMAILS_FLAG_KEY = 'nav.scheduledEmails';

/**
 * Does this CLIENT show the Scheduled Emails page under Admin?
 *
 * That page only, by the owner's decision: the nav entry and AdminRouteGuard
 * (requiredClientFlag) read it, and nothing else does. The schedule editors on
 * the report pages, the email drawers, users' own subscriptions and the
 * server's report-notifications routes are not gated on it.
 *
 * SOURCE OF TRUTH: `region.uiSettings.scheduledEmailsEnabled` in Mongo,
 * switched on by the SNF AI admin (177) on Client Settings, reaching the app
 * through snfs/getClientSettings.
 *
 * OPT-IN, like RiskAI and the Discharge Plan: an unconfigured region hides
 * the page and only an explicit `true` shows it.
 *
 * WHY localStorage: read synchronously by callers that cannot inject
 * ClientSettingsService, or that run before it has loaded; ClientSettingsService
 * caches this one key on every load, exactly as it does for `newNavigation`.
 * The cache is a read-ahead, never the authority: the region's value overwrites
 * it on the next load, and it is per-browser. Nothing cached reads as OFF;
 * AdminRouteGuard waits for the load before it decides.
 */
export function isScheduledEmailsEnabledForClient(): boolean {
  return localStorageGet(SCHEDULED_EMAILS_FLAG_KEY) === true;
}
